import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  error: "",
  success: "",
  loginGuestSuccess: null,
  loginGuestError: false,
  loginGuestViolations: null,
  user: {}
};

const ProfileSlice = createSlice({
  name: "Profile",
  initialState,
  reducers: {
    profileSuccess(state, action) {
      state.success = action.payload.status;
      state.user = action.payload.data
    },
    profileError(state, action) {
        state.error = action.payload
    },
    resetProfileFlagChange(state){
      state.success = null
    },
    loginGuestSuccess(state, action) {
      state.user = action.payload
      state.loginGuestSuccess = true
    },
    loginGuestError(state, action) {
      state.loginGuestError = true
      state.loginGuestViolations = action.payload;
    },
    loginGuestReset(state) {
      state.loginGuestError = null
      state.loginGuestViolations = null;
      state.loginGuestSuccess = null;
    },
  },
});

export const {
    profileSuccess,
    profileError,
    resetProfileFlagChange,
    loginGuestSuccess,
    loginGuestError,
    loginGuestReset
} = ProfileSlice.actions

export default ProfileSlice.reducer;
